import React, { useCallback, useContext, useRef } from "react";
import {
  callApi,
  isEmpty,
  addZero,
  getDwk,
  convertDateTime,
  getTimeText,
  replaceTag,
  recoverTag,
} from "bodycodi/cmap/app/js/common";
import Drawer from "@material-ui/core/Drawer";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { DispatchContext as HomeDispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";

import empty from "bodycodi/cmap/app/img/member-profile-empty.png";

import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";

type ConditionConfirmProp = {
  scheduleType: string;
  time: any;
  center: any;
  chooseDate: any;
  member: any;
  handleReset: Function;
  scheduleTitle: string;
  csDecs: string;
  startTime: any;
  endTime: any;
};

const ConditionOtConfirmWrap = (prop: ConditionConfirmProp) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = useCallback(() => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CONFIRM_CONDITION_OT",
      open: { cofirmConditionOt: false },
    });
    prop.handleReset();
  }, []);

  return (
    <Drawer
      anchor="bottom"
      open={state.cofirmConditionOt}
      onClose={handleClose}
      className="picker-pop auto"
    >
      {state.cofirmConditionOt && <ConditionOtConfirm {...prop} />}
    </Drawer>
  );
};

const ConditionOtConfirm = ({
  scheduleType,
  time,
  center,
  chooseDate,
  member,
  scheduleTitle,
  csDecs,
  startTime,
  endTime,
}: ConditionConfirmProp) => {
  const { seqPartner, seqPartnerBranch, seqPartnerCoach, partnerName, partnerBranchName } =
    useSelector((state: RootState) => state.partner);
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const imgUrl = isEmpty(member.imgUrl) ? empty : member.imgUrl;
  const date = new Date(
    `${chooseDate.year}-${addZero(chooseDate.month)}-${addZero(chooseDate.date)}`
  );
  const statDateTime = convertDateTime(chooseDate, startTime);
  const endDateTime = convertDateTime(chooseDate, endTime);
  const isLoadingRef = useRef<boolean>(false);

  const handleClose = useCallback(() => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CONFIRM_CONDITION_OT",
      open: { cofirmConditionOt: false },
    });
  }, []);

  const appointmentRsrv = () => {
    if (isLoadingRef.current === true) return;
    isLoadingRef.current = true;
    dispatch({ type: "LOADING_START" });
    callApi(
      "/schedule/reservation/ot",
      {
        appointmentClCd: scheduleType,
        seqPartner,
        seqPartnerBranch,
        seqPartnerCoach,
        seqMember: member.seqMember,
        startDate: statDateTime,
        endDate: endDateTime,
        startDt: statDateTime.split(" ")[0],
        endDt: endDateTime.split(" ")[0],
        startTime: `${startTime.hour.toString().padStart(2, "0")}:${startTime.min
          .toString()
          .padStart(2, "0")}`,
        endTime: `${endTime.hour.toString().padStart(2, "0")}:${endTime.min
          .toString()
          .padStart(2, "0")}`,
        scheduleName: replaceTag(scheduleTitle),
        memo: csDecs,
      },
      "POST"
    )
      .then((res) => {
        if (res.MsgVO.msgCd === "CMAP2040-00") {
          handleClose();
          homeDispatch({ type: "UPDATE_SCHDULE" });
          dispatch({
            type: "UPDATE",
            data: { toast: true, toastText: "<span>OT 스케줄</span>이 추가되었어요" },
          });
          isLoadingRef.current = false;
        } else {
          dispatch({ type: "UPDATE", data: { toast: true, toastText: res.MsgVO.msgCtnt } });
          isLoadingRef.current = false;
        }
      })
      .finally(() => {
        dispatch({ type: "LOADING_END" });
        isLoadingRef.current = false;
      });
  };

  return (
    <Drawer
      anchor="bottom"
      open={state.cofirmConditionOt}
      onClose={handleClose}
      className="picker-pop auto"
    >
      <div className="condition-confirm-pop">
        <img src={imgUrl} className="profile" />
        <div className="title">
          {member.name}님을
          <br />
          <span>OT 예약</span> 할까요?
        </div>
        <div className="date-wrap">
          <ul>
            <li>
              <span className="bold">
                {chooseDate.month}. {addZero(chooseDate.date)}
              </span>{" "}
              <span className="bold">({getDwk(date.getDay())})</span>
            </li>
            <li>
              {getTimeText(startTime)} - {getTimeText(endTime)}
            </li>
          </ul>
        </div>
        <div className="condition-schdule ap">
          <div className="lesson-decs">
            <div className="service-type">OT</div>
            <div className="lesson-name memo1">{recoverTag(scheduleTitle)}</div>
            <div className="partner-name">
              {partnerName} {partnerBranchName}
            </div>
          </div>
        </div>
        <div className="tip textarea" style={{ textAlign: "center" }}>
          OT 스케줄 시간에는 개인레슨을 예약할 수 없습니다.
        </div>
        <div className="member-decution-btn-wrap">
          <div className="btn cancle" onClick={handleClose}>
            취소
          </div>
          <div className="btn rsrv" onClick={appointmentRsrv}>
            예약하기
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default ConditionOtConfirmWrap;
